import axios from "@api/axiosInstance";
import { useMutation, useQuery } from "@tanstack/react-query";
import { DesignAutomationsClient, PluginHistory } from "./apiClient";

const designAutomationsClient = new DesignAutomationsClient(undefined, axios);

export const usePluginsHistory = (options?: any) => {
  return useQuery<PluginHistory[]>({
    ...options,
    queryKey: ["pluginsHistory"],
    queryFn: async () => designAutomationsClient.getPluginsHistory(),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes    
  });
};

export const useResetPlugins = (options?: any) => {
  return useMutation<void>({
    ...options,
    mutationFn: () => designAutomationsClient.resetPlugins(),
  });
};